<!--
 * @Description  : 企业申诉弹窗审核
 * @Author       : 王帅
 * @Date         : 2026-05-12 11:14:22
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-05-29 10:11:25
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\audit-affairs-new\components\audit-appeal.vue
-->
<template>
	<el-dialog
		title="企业申诉"
		:visible.sync="dialogShow"
		center
		top="3vh"
		:close-on-click-modal="false"
		custom-class="shensu-dialog"
		width="1000px"
		@closed="closeAppeal"
		destroy-on-close
	>
		<div class="current-main">
			<bm-panel title="#1 申诉人信息">
				<el-form :model="userForm" label-width="150px" class="view-form">
					<el-form-item label="身份证">
						<div class="flex">
							<div class="upload-item">
								<public-upload
									class="id-upload"
									isViewMode
									:viewFilesList="filterFiles('sys_user', 'idcard_1')"
									listType="picture-card"
								></public-upload>
								<div class="upload-text">人像面</div>
							</div>
							<div class="upload-item">
								<public-upload
									class="id-upload"
									isViewMode
									:viewFilesList="filterFiles('sys_user', 'idcard_2')"
									listType="picture-card"
								></public-upload>
								<div class="upload-text">国徽面</div>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="手机号">{{ userForm.phone }}</el-form-item>
					<el-form-item label="身份证号">{{ userForm.idCard }}</el-form-item>
					<el-form-item label="姓名">{{ userForm.sname }}</el-form-item>
					<el-form-item label="证明材料">
						<div style="width:600px;">
							<public-upload
								emptyOnlyShowText
								isViewMode
								:viewFilesList="filterFiles('sys_user', 'otherFile')"
								ref="otherFile"
								listType="text"
								viewHeight="60px"
							></public-upload>
						</div>
					</el-form-item>
				</el-form>
			</bm-panel>
			<!-- 企业信息 -->
			<bm-panel title="#2 申诉企业信息">
				<el-form :model="companyForm" class="view-form" ref="userForm" label-width="150px">
					<el-form-item label="申诉类型">我要找回我的企业</el-form-item>
					<el-form-item label="单位类型">{{ companyForm.flatTypeName }}</el-form-item>
					<el-form-item label="申诉材料">
						<div class="flex">
							<div class="upload-item">
								<public-upload
									class="id-upload"
									isViewMode
									:viewFilesList="filterFiles('sys_tenant_interim', 'shensuInfo_zz')"
									listType="picture-card"
								></public-upload>
								<div class="upload-text">营业执照</div>
							</div>
							<div class="upload-item">
								<public-upload
									class="id-upload"
									isViewMode
									:viewFilesList="filterFiles('sys_tenant_interim', 'shensuInfo_ss')"
									listType="picture-card"
								></public-upload>
								<div class="upload-text">企业申诉书（盖章）</div>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="申诉企业名称">{{ companyForm.sname }}</el-form-item>
					<el-form-item label="统一社会信用代码">{{ companyForm.creditCode }}</el-form-item>
					<el-form-item label="法人代表姓名">{{ companyForm.legal }}</el-form-item>
					<el-form-item label="法人代表手机号">{{ companyForm.legalPhone }}</el-form-item>
				</el-form>
			</bm-panel>
			<!-- 审核信息 -->
			<bm-panel title="3 审核信息">
				<el-form :model="resultForm" ref="resultForm" label-width="150px" :rules="resultRules">
					<el-form-item label="自动审核结果">
						<div class="info-content">
							<p class="info-row" v-for="(item, index) in autoResults" :key="'result' + index">{{ item }}</p>
						</div>
					</el-form-item>
					<el-form-item label="审核结果" prop="status">
						<el-select v-model="resultForm.status" placeholder="请选择" v-if="mode != 'view'">
							<el-option label="通过" :value="1"></el-option>
							<el-option label="驳回" :value="2"></el-option>
						</el-select>
						<div v-else>{{ resultForm.status == 1 ? '通过' : '驳回' }}</div>
					</el-form-item>
					<el-form-item label="审核意见" prop="remark">
						<el-input
							type="textarea"
							v-model="resultForm.remark"
							maxlength="200"
							show-word-limit
							:autosize="{ minRows: 5 }"
							v-if="mode != 'view'"
						></el-input>
						<div class="info-text" v-else>{{ resultForm.remark }}</div>
					</el-form-item>
					<template v-if="mode == 'view'">
						<el-form-item label="审核人">{{ resultForm.upUserSname }}</el-form-item>
						<el-form-item label="审核时间">{{ resultForm.updateDate }}</el-form-item>
					</template>
				</el-form>
			</bm-panel>
		</div>

		<div slot="footer" v-if="mode != 'view'">
			<el-button class="btn" @click="dialogShow = false">取 消</el-button>
			<el-button type="primary" class="btn btn-blue" :loading="btnLoading" @click="doSubmit">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
// api
import { getRecordDetail } from 'api/modules/audit'
import { auditSubmit } from 'api/modules/invoice'

// components
import bmPanel from '@/components/panel/Panel'
export default {
	name: '',
	components: { bmPanel },
	props: {
		rowData: {
			type: Object,
			deafault: () => {
				return {}
			}
		},
		mode: {
			type: String,
			default: ''
		},
		// 是否展示企业
		showCompany: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			dialogShow: false,
			btnLoading: false,
			userForm: {},
			userForm: {},
			companyForm: {},
			autoResults: [], // 自动审核结果
			viewFilesList: [],
			resultForm: {
				status: '',
				remark: ''
			},
			resultRules: {
				status: [{ required: true, message: '不能为空', trigger: 'change' }],
				remark: [{ required: true, message: '不能为空', trigger: 'blur' }]
			}
		}
	},
	methods: {
		//TODO 打开弹窗
		openDialog() {
			this.dialogShow = true
			this.getDetailInfo()
		},
		//* 初始获取信息
		getDetailInfo() {
			this.viewFilesList = []
			getRecordDetail({
				recordId: this.rowData.id,
				id: this.rowData.id
			}).then((res) => {
				this.userForm = res.data.userInfo
				this.companyForm = res.data.tenantJson

				if (this.mode == 'view' && res.data.applyRecords.length > 0) {
					this.resultForm = res.data.applyRecords[0]
				}

				let baseFiles = res.data.userInfo.baseFiles || []
				let zmFiles = res.data.userInfo.zmFiles || []
				this.viewFilesList = baseFiles.concat(zmFiles).concat(res.data.tenantJson.files)
			})
		},

		//! 附件数组判断
		filterFiles(tableName, assortmrnt) {
			return this.viewFilesList.filter((x) => x.tableName == tableName && x.assortment == assortmrnt)
		},

		//TODO 确认提交
		doSubmit() {
			this.$refs.resultForm.validate((valid) => {
				if (valid) {
					auditSubmit({
						id: this.rowData.id,
						busId: this.rowData.busId,
						busType: this.rowData.busType,
						status: this.resultForm.status,
						remark: this.resultForm.remark
					})
						.then((res) => {
							this.$message.success('审核完成')
							this.closeAppeal()
						})
						.catch(() => {
							setTimeout(() => {
								this.btnLoading = false
							}, 1500)
							this.$emit('btnClose')
						})
				} else {
					setTimeout(() => {
						this.btnLoading = false
					}, 1500)
					this.$emit('btnClose')
				}
			})
		},

		// 关闭时触发
		closeAppeal() {
			this.$emit('closeAppeal', false)
		}
	},
	created() {
		this.getDetailInfo()
		this.autoResults = this.rowData.autoResults.split(',')
	},
	computed: {}
}
</script>
<style scoped lang="less">
.upload-item {
	width: 200px;
	margin-right: 20px;
	text-align: center;
}
.view-form /deep/ .el-form-item {
	margin-bottom: 0;
}

.info-content {
	padding: 8px 0;
	line-height: 24px;
	color: #cf000d;
}

.info-text {
	padding: 8px 0;
	line-height: 24px;
}
</style>
